/* MakerToy Theme - main.js */

// ── FREE SHIPPING PROGRESS ─────────────────────────
// Threshold (in pence) is set by theme.liquid when the feature is enabled.
window.MTFreeShip = {
  get threshold() { return window.MT_FREE_SHIP_THRESHOLD || 0; },
  get enabled() { return this.threshold > 0; },

  money(pence) { return '£' + (pence / 100).toFixed(2); },

  message(totalPence) {
    const remaining = this.threshold - totalPence;
    return remaining > 0
      ? `🚚 You're <strong>${this.money(remaining)}</strong> away from <strong>FREE UK shipping</strong>`
      : `🎉 You've unlocked <strong>FREE UK shipping</strong>!`;
  },

  // Sync every [data-free-ship] bar on the page with a /cart.js response
  update(cart) {
    if (!this.enabled || !cart) return;
    const pct = Math.min(100, Math.round((cart.total_price / this.threshold) * 100));
    const unlocked = cart.total_price >= this.threshold;
    document.querySelectorAll('[data-free-ship]').forEach(bar => {
      const msg = bar.querySelector('[data-free-ship-msg]');
      if (msg) msg.innerHTML = this.message(cart.total_price);
      const track = bar.querySelector('[data-free-ship-track]');
      if (track) track.setAttribute('aria-valuenow', pct);
      const fill = bar.querySelector('[data-free-ship-fill]');
      if (fill) {
        fill.style.width = pct + '%';
        fill.classList.toggle('free-ship-fill--done', unlocked);
      }
    });
  },

  // Small toast after add-to-cart: "£x away from free shipping"
  toast(cart) {
    if (!this.enabled || !cart || cart.item_count === 0) return;
    document.querySelector('.free-ship-toast')?.remove();
    const el = document.createElement('div');
    el.className = 'free-ship-toast';
    el.setAttribute('role', 'status');
    el.innerHTML = this.message(cart.total_price);
    document.body.appendChild(el);
    setTimeout(() => el.classList.add('show'), 20);
    setTimeout(() => {
      el.classList.remove('show');
      setTimeout(() => el.remove(), 400);
    }, 4000);
  },

  // Fetch the cart then update bars + optionally show the toast
  async refresh(showToast) {
    if (!this.enabled) return;
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      this.update(cart);
      if (showToast) this.toast(cart);
    } catch {}
  }
};

document.addEventListener('DOMContentLoaded', () => {

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ── STICKY HEADER SHADOW ─────────────────────────
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  // ── MOBILE NAV ───────────────────────────────────
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', () => {
      hamburger.classList.toggle('open');
      mobileNav.classList.toggle('open');
      const isOpen = mobileNav.classList.contains('open');
      hamburger.setAttribute('aria-expanded', isOpen);
      hamburger.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
    mobileNav.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => {
        hamburger.classList.remove('open');
        mobileNav.classList.remove('open');
        hamburger.setAttribute('aria-expanded', 'false');
        hamburger.setAttribute('aria-label', 'Open menu');
        document.body.style.overflow = '';
      });
    });
  }

  // ── SCROLL REVEAL ────────────────────────────────
  const revealEls = document.querySelectorAll('.reveal, .reveal-left, .reveal-right');
  if (revealEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -48px 0px' });
    revealEls.forEach(el => io.observe(el));
  }

  // ── PARALLAX HERO BLOBS ──────────────────────────
  const blobs = document.querySelectorAll('.hero-blob');
  if (blobs.length && window.innerWidth > 900 && !reducedMotion) {
    window.addEventListener('mousemove', (e) => {
      const cx = window.innerWidth / 2;
      const cy = window.innerHeight / 2;
      const dx = (e.clientX - cx) / cx;
      const dy = (e.clientY - cy) / cy;
      blobs.forEach((b, i) => {
        const strength = i === 0 ? 18 : 12;
        b.style.transform = `translate(${dx * strength}px, ${dy * strength}px)`;
      });
    }, { passive: true });
  }

  // ── ORBIT DOTS TILT ──────────────────────────────
  const ringWrap = document.querySelector('.ring-wrap');
  if (ringWrap && window.innerWidth > 900 && !reducedMotion) {
    ringWrap.addEventListener('mousemove', (e) => {
      const rect = ringWrap.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      const rotX = ((e.clientY - cy) / rect.height) * 12;
      const rotY = ((e.clientX - cx) / rect.width) * -12;
      ringWrap.style.transform = `perspective(600px) rotateX(${rotX}deg) rotateY(${rotY}deg)`;
    });
    ringWrap.addEventListener('mouseleave', () => {
      ringWrap.style.transform = 'perspective(600px) rotateX(0) rotateY(0)';
    });
  }

  // ── PARTICLE BURST ON ARM CARD HOVER ─────────────
  function burst(el, color) {
    const rect = el.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;
    for (let i = 0; i < 8; i++) {
      const p = document.createElement('div');
      const angle = (i / 8) * Math.PI * 2;
      const dist = 40 + Math.random() * 30;
      const size = 4 + Math.random() * 4;
      Object.assign(p.style, {
        position: 'fixed',
        left: cx + 'px', top: cy + 'px',
        width: size + 'px', height: size + 'px',
        borderRadius: '50%',
        background: color,
        pointerEvents: 'none',
        zIndex: 9998,
        transform: 'translate(-50%,-50%)',
        transition: 'transform 0.6s ease-out, opacity 0.6s ease-out',
        opacity: '1',
      });
      document.body.appendChild(p);
      requestAnimationFrame(() => {
        p.style.transform = `translate(calc(-50% + ${Math.cos(angle) * dist}px), calc(-50% + ${Math.sin(angle) * dist}px))`;
        p.style.opacity = '0';
      });
      setTimeout(() => p.remove(), 700);
    }
  }

  if (!reducedMotion) {
    document.querySelectorAll('.arm-card').forEach(card => {
      const color = card.classList.contains('arm-card-loot') ? '#C0274A'
        : card.classList.contains('arm-card-chunk') ? '#2AABAA' : '#7B4F9E';
      card.addEventListener('mouseenter', () => burst(card, color));
    });
  }

  // ── ANIMATED COUNTER FOR STAT PILLS ──────────────
  function animateCount(el, target, duration = 1200) {
    const start = performance.now();
    const update = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const ease = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.round(ease * target) + (el.dataset.suffix || '');
      if (progress < 1) requestAnimationFrame(update);
    };
    requestAnimationFrame(update);
  }

  const counters = document.querySelectorAll('[data-count]');
  if (counters.length) {
    const cio = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          animateCount(e.target, parseInt(e.target.dataset.count));
          cio.unobserve(e.target);
        }
      });
    }, { threshold: 0.5 });
    counters.forEach(el => cio.observe(el));
  }

  // ── CHUNK FIGURE EASTER EGG ───────────────────────
  const chunkFigs = document.querySelectorAll('.chunk-fig');
  let clickCount = 0;
  chunkFigs.forEach(fig => {
    fig.addEventListener('click', () => {
      clickCount++;
      fig.style.animation = 'none';
      fig.offsetHeight; // reflow
      fig.style.animation = 'wiggle 0.4s ease';
      if (clickCount >= 6) {
        const msg = document.createElement('div');
        Object.assign(msg.style, {
          position: 'fixed', bottom: '2rem', left: '50%',
          transform: 'translateX(-50%)',
          background: '#2AABAA', color: '#fff',
          padding: '1rem 2rem', borderRadius: '999px',
          fontFamily: 'Nunito, sans-serif', fontWeight: '800',
          fontSize: '1rem', zIndex: 9999,
          boxShadow: '0 8px 32px rgba(42,171,170,0.4)',
          animation: 'fadeInUp 0.4s ease',
        });
        msg.textContent = '🧩 Psst… Chunkables are almost here! Follow us to be first to know.';
        document.body.appendChild(msg);
        setTimeout(() => msg.remove(), 3500);
        clickCount = 0;
      }
    });
  });

  // ── CART AJAX ────────────────────────────────────
  document.querySelectorAll('.pc-btn[data-variant-id]').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.textContent = 'Adding…';
      btn.disabled = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        if (res.ok) {
          btn.textContent = '✓ Added!';
          updateCartCount().then(cart => cart && window.MTFreeShip.toast(cart));
          setTimeout(() => { btn.textContent = 'Add to Cart'; btn.disabled = false; }, 2000);
        } else {
          btn.textContent = 'Error'; btn.disabled = false;
        }
      } catch {
        btn.textContent = 'Add to Cart'; btn.disabled = false;
      }
    });
  });

  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
      window.MTFreeShip.update(cart);
      return cart;
    } catch {}
  }
  updateCartCount();

  // Announcement marquee: theme.liquid already renders two copies of
  // .announcement-inner, which is exactly what the -50% loop needs.
  // Cloning a third here made the animation jump every cycle.

});

// ── CSS KEYFRAME INJECTOR (wiggle, fadeInUp) ──────
const extraStyles = document.createElement('style');
extraStyles.textContent = `
@keyframes wiggle {
  0%,100% { transform: rotate(0deg) scale(1.08); }
  25% { transform: rotate(-8deg) scale(1.08); }
  75% { transform: rotate(8deg) scale(1.08); }
}
@keyframes fadeInUp {
  from { opacity: 0; transform: translateX(-50%) translateY(16px); }
  to   { opacity: 1; transform: translateX(-50%) translateY(0); }
}
.announcement-wrap { overflow: hidden; }
.announcement-track {
  display: flex; width: max-content;
  animation: marquee 24s linear infinite;
}
.announcement-inner { padding: 0 3rem; white-space: nowrap; }
@keyframes marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }
@media (prefers-reduced-motion: reduce) {
  .announcement-track { animation: none; }
}
`;
document.head.appendChild(extraStyles);
